import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AddInvoicesByAdmin from "./addInvoicesByAdmin";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Pagination } from "react-bootstrap";
import AddInvoiceTransaction from "./invoiceTransactionPopup";
import { format, parse } from "date-fns";
import { FiInfo } from "react-icons/fi";
import InvoiceTransactionsHistory from "./invoiceTransactionsHistory";

function OutgoingAdminInvoices() {
  const [outgoingInvoices, setOutgoingInvoices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTransactionPopupOpen, setIsTransactionPopupOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [labs, setLabs] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedLab, setSelectedLab] = useState("all");
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState(null);
  const [labTypeFilter, setLabTypeFilter] = useState("all");
  const [selectedDate, setSelectedDate] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    const [isInvoiceTransactionModalOpen, setIsInvoiceTransactionModalOpen] = useState(false);
  

  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (searchTerm || selectedLab !== "all" || selectedCompany !== "all" || invoiceNumberFilter || selectedDate || statusFilter !== "all" || labTypeFilter !== "all") {
      setCurrentPage(0); // Reset page before fetching new search data
    }
  }, [searchTerm, selectedLab, selectedCompany, invoiceNumberFilter, selectedDate, statusFilter, labTypeFilter]);
  
  useEffect(() => {
    if (searchTerm || selectedLab !== "all" || selectedCompany !== "all" || invoiceNumberFilter || selectedDate || statusFilter !== "all" || labTypeFilter !== "all") {
      searchData(currentPage); // Fetch new search data with updated page number
    } else {
      getData(currentPage);
    }
  }, [searchTerm, selectedLab, selectedCompany, invoiceNumberFilter, selectedDate, statusFilter, labTypeFilter, currentPage]);
  
  const searchData = async (page = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/invoiceSearch/searchAdminOutgoingInvoices?page=${page}`;
      const requestData = {
        invoiceNumber: invoiceNumberFilter || null,
        date: selectedDate || null,
        labId: selectedLab === "all" ? null : selectedLab,
        companyId: selectedCompany === "all" ? null : selectedCompany,
        status: statusFilter === "all" ? null : statusFilter,
        labType: labTypeFilter === "all" ? null : labTypeFilter,
        createdBy:"Admin"
      };

      const response = await axios.post(searchUrl, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setOutgoingInvoices(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/invoices/getAllAdminInvoices/invoiceType=outgoing`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setOutgoingInvoices(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      const labRes = await axios.get("/api/labdetails/getLabs", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabs(labRes.data);

      const response = await axios.get("/api/companydetails/getCompanies", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanies(response.data);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleLabFilterChange = (event) => {
    setSelectedLab(event.target.value);
    setSelectedCompany(null);
  };

  const handleCompanyFilterChange = (event) => {
    setSelectedCompany(event.target.value);
    setSelectedLab(null);
    setLabTypeFilter(null);
  };

  const handleSearchInvoiceNumber = (event) => {
    setInvoiceNumberFilter(event.target.value.toLowerCase());
  };

  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/yyyy");
      setSelectedDate(formattedDate); 
    } else {
      setSelectedDate(null);
    }
  };

  const handleOpenTransactionHistory = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setIsInvoiceTransactionModalOpen(true);
  };
  const handleCloseInvoiceTransactionModal = () => {
    setIsInvoiceTransactionModalOpen(false);
    setSelectedInvoiceId(null);
    searchData(0);
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleLabTypeFilterChange = (e) => {
    setLabTypeFilter(e.target.value);
    setSelectedCompany(null);
  };

  const handleViewPdf = async (id) => {
    await axios({
      url: `/api/invoices/download/id=${id}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"];
      let extension = "";

      if (contentType.includes("application/pdf")) {
        extension = "pdf";
      } else if (contentType.includes("image/jpeg")) {
        extension = "jpg";
      } else if (contentType.includes("image/png")) {
        extension = "png";
      } else {
        console.error("Unsupported file type:", contentType);
        return;
      }

      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file.${extension}`);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    });
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const handleCreateCompany = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleOpenTransactionPopup =async (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setIsTransactionPopupOpen(true);
  };

  const handleCloseTransactionModal = () => {
    setIsTransactionPopupOpen(false);
    setSelectedInvoiceId(null);

    getData();
  };



  return (
    <div>
        <div className="col-12 mx-xl-auto">
          <br />
          <div className="card card-raised">
            <div className="card-body">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Outgoing Invoices :</span>
                <div>
                  <button className="btn btn-primary" onClick={handleCreateCompany}>
                    ADD
                  </button>
                </div>
              </div>

              <br />
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label htmlFor="labFilter" className="form-label">
                    Filter by Lab:
                  </label>
                  <select
                    id="labFilter"
                    className="form-select"
                    value={selectedLab || "all"}
                    onChange={handleLabFilterChange}
                  >
                    <option value="all">All Labs</option>
                    {labs.map((lab) => (
                      <option key={lab.id} value={lab.id}>
                        {lab.labname} - {lab.labcode}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="labTypeFilter" className="form-label">
                    Filter by Lab Type:
                  </label>
                  <select
                    id="labTypeFilter"
                    className="form-select"
                    value={labTypeFilter || "all"}
                    onChange={handleLabTypeFilterChange}
                  >
                    <option value="all">ALL</option>
                    <option value="Regulated">Regulated</option>
                    <option value="Unregulated">Unregulated</option>
                  </select>
                </div>

                <div className="col-md-3 mb-3">
              <label htmlFor="companyFilter" className="form-label">
                Filter by Company:
              </label>
              <select
                id="companyFilter"
                className="form-select"
                value={selectedCompany || "all"}
                onChange={handleCompanyFilterChange}
              >
                <option value="all">All Companies</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.companyname}
                  </option>
                ))}
              </select>
            </div>

               <div className="col-md-3 mb-3">
                  <label htmlFor="statusFilter" className="form-label">
                    Filter by Status:
                  </label>
                  <select
                    id="statusFilter"
                    className="form-select"
                    value={statusFilter || "all"}
                    onChange={handleStatusFilterChange}
                  >
                    <option value="all">ALL</option>
                    <option value="Invoice Generated">INVOICE GENERATED</option>
                    <option value="Partial Payment">PARTIAL PAYMENT</option>
                    <option value="Paid">PAID</option>
                  </select>
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="invoiceNumberFilter" className="form-label">
                    Search by Invoice Number:
                  </label>
                  <input
                    type="search"
                    className="form-control"
                    id="invoiceNumberFilter"
                    placeholder="Search by Invoice Number"
                    value={invoiceNumberFilter}
                    onChange={handleSearchInvoiceNumber}
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="monthYearFilter" className="form-label">
                    Filter by Month and Year:
                  </label>
                  <DatePicker
  selected={selectedDate ? parse(selectedDate, "MM/yyyy", new Date()) : null}
  onChange={handleDateChange}
  showMonthYearPicker
  dateFormat="MM/yyyy"
  className="form-select"
  placeholderText="Select Month and Year"
/>

                </div>
              </div>

               <div className="table-responsive">     
              <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                  <th>Lab</th>
                    <th>Lab Type</th>
                    <th>Lab Address</th>
                    <th>Company</th>
                    <th>Date</th>
                    <th>Period</th>
                    <th>Invoice Number</th>
                    <th>Gross Amount</th>
                    <th>Tax</th>
                    <th>Net Pay</th>
                    <th>File</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {outgoingInvoices.length === 0 ? (
                    <tr>
                      <td colSpan="15" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    outgoingInvoices.map((invoice) => (
                      <tr key={invoice.id}>
                        {/* Display lab details or "NA" if company exists */}
                        <td>
                          {invoice.company ? "NA" : invoice.lab?.labname} 
                          {invoice.company ? "" : `(${invoice.lab?.labcode})`}
                        </td>
                    
                        {/* Display lab regulated status or "NA" if company exists */}
                        <td>
                          {invoice.company ? "NA" : (invoice.lab?.regulated === true ? "Regulated" : "Unregulated")}
                        </td>
                    
                        {/* Display lab address or "NA" if company exists */}
                        <td>
                          {invoice.company ? "NA" : invoice.lab?.addressLine1}
                        </td>
                    
                        {/* Display company details or "NA" if lab exists */}
                        <td>
                          {invoice.lab ? "NA" : invoice.company?.companyname} 
                          {invoice.lab ? "" : `(${invoice.company?.companycode})`}
                        </td>
                    
                        <td>{invoice.date}</td>
                        <td>
                          {invoice.startdate} to {invoice.enddate}
                        </td>
                        <td>{invoice.invoicenumber}</td>
                        <td>₹{invoice.grossamount}</td>
                        <td>{invoice.tax}%</td>
                        <td>₹{invoice.netpay}</td>
                        <td>
                        {invoice.invoiceFileUploaded===true ? (
                          <button
                            className="btn btn-primary"
                            onClick={() => handleViewPdf(invoice.id)}
                          >
                            View
                          </button>
                        ) : (
                          "No File Added"
                        )}
                        </td>
                        <td>
                          <div style={{ display: "flex", alignItems: "center" }}>
  {invoice.invoiceStatus?.status}
  {invoice.invoiceStatus?.status === "Paid" && (
    <FiInfo
      onClick={() => handleOpenTransactionHistory(invoice.id)}
      style={{
        cursor: "pointer",
        marginLeft: "8px", // Adjust spacing as needed
      }}
    />
  )}
  </div>
<br/>
{invoice.invoiceStatus?.status === "Partial Payment" && (
  <>
    <div style={{ color: "green", fontWeight: "bold" }}>
        Paid : ₹{invoice.paidAmount}
      </div>

      <div style={{ color: "red", fontWeight: "bold" }}>
        Pending: ₹{invoice.pendingAmount}
      </div>
</>
)}
{invoice.invoiceStatus?.status !== "Paid" && (
  <>
    <button
      className="btn btn-success btn-sm rounded-pill"
      onClick={() => handleOpenTransactionPopup(invoice.id)}
    >
      Payment Received
    </button>
  </>
)}

</td>


                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              </div>
              <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>

              <div>
                {isModalOpen && <AddInvoicesByAdmin isOpen={isModalOpen} onRequestClose={handleCloseModal} />}
              </div>
              <div>
                {isTransactionPopupOpen && <AddInvoiceTransaction isOpen={isTransactionPopupOpen} onRequestClose={handleCloseTransactionModal} invoiceid={selectedInvoiceId} />}
              </div>
              {isInvoiceTransactionModalOpen && (
                    <InvoiceTransactionsHistory isOpen={isInvoiceTransactionModalOpen} onRequestClose={handleCloseInvoiceTransactionModal} invoiceId={selectedInvoiceId}/>
                  )}
            </div>
          </div>
        </div>
      {loader && <div className="loading"></div>}
    </div>
  );
}

export default OutgoingAdminInvoices;
